import type { GetSubmissionSpreadResponse } from '@gdladder/shared/features';
import { useQuery } from '@tanstack/react-query';
import APIClient from '../../../../api/APIClient';

function toRatingSpread(data: Record<string, number>) {
    return Object.entries(data).map(([key, value]) => ({ Rating: Number(key), Count: value }));
}

export async function getSubmissionSpread(levelID: number) {
    const res = await APIClient.get<GetSubmissionSpreadResponse>(`/levels/${levelID}/submissions/spread`);
    const data = res.data;

    return {
        rating: toRatingSpread(data.rating),
        twoPlayerRating: toRatingSpread(data.twoPlayerRating),
        weightedRating: toRatingSpread(data.weightedRating ?? {}),
        twoPlayerWeightedRating: toRatingSpread(data.twoPlayerWeightedRating ?? {}),
        deweightedRating: toRatingSpread(data.deweightedRating ?? {}),
        twoPlayerDeweightedRating: toRatingSpread(data.twoPlayerDeweightedRating ?? {}),
        enjoyment: Object.entries(data.enjoyment).map(([key, value]) => ({ Enjoyment: Number(key), Count: value })),
        twoPlayerEnjoyment: Object.entries(data.twoPlayerEnjoyment).map(([key, value]) => ({
            Enjoyment: Number(key),
            Count: value,
        })),
    };
}

export function useLevelSubmissionSpread(levelID: number, enabled = true) {
    return useQuery({
        queryKey: ['level', levelID, 'submissions', 'spread'],
        queryFn: () => getSubmissionSpread(levelID),
        enabled,
    });
}
